var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgMoneyOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51783 4.81642C7.89607 4.59806 7.89607 4.24403 7.51783 4.02567C7.13959 3.80731 6.52634 3.80731 6.1481 4.02567C5.76986 4.24403 5.76986 4.59806 6.1481 4.81642C6.52634 5.03477 7.13959 5.03477 7.51783 4.81642Z",
    fill: "var(--secondary-7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74662 0.554688L13.2223 3.28981L5.25348 8.15963L0.777832 5.42451L8.74662 0.554688ZM2.74285 5.42451L3.47654 5.87287L4.92598 5.04851L5.88411 5.4931L4.4355 6.4589L5.25348 6.95878L11.2573 3.28981L10.3182 2.71593L8.64954 3.76479L7.69141 3.3202L9.42055 2.16738L8.74662 1.75553L2.74285 5.42451Z",
    fill: "var(--secondary-7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4748 7.52889L0.777832 8.56593L5.25348 11.301L13.2223 6.43123L11.5253 5.39419L10.5428 5.99462L11.2573 6.43123L5.25348 10.1002L2.74285 8.56593L3.45731 8.12931L2.4748 7.52889Z",
    fill: "var(--secondary-7)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyOutlined);
export default __webpack_public_path__ + "static/media/moneyOutlined.fc0b40dc35aa3b21b3db9411da7d1f3a.svg";
export { ForwardRef as ReactComponent };